import * as yup from 'yup';
import {
  errorName,
  errorRequired,
  isValidUsername,
  isValidURL,
  errorInvalidUrl
} from '../../../constants/validation';

export const profileSchema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required(errorRequired)
    .min(2, 'First name must be at least 2 characters')
    .test('is-valid-username', errorName, isValidUsername),
  lastName: yup.string().trim().test('is-valid-username', errorName, isValidUsername).nullable(),
  description: yup.string().trim().nullable(),
  facebook: yup.string().trim().test('is-valid-url', errorInvalidUrl, isValidURL).nullable(),
  twitter: yup.string().trim().test('is-valid-url', errorInvalidUrl, isValidURL).nullable(),
  linkedin: yup.string().trim().test('is-valid-url', errorInvalidUrl, isValidURL).nullable(),
  instagram: yup.string().trim().test('is-valid-url', errorInvalidUrl, isValidURL).nullable(),
  username: yup
    .string()
    .trim()
    .required(errorRequired)
    .matches(/^[a-zA-Z0-9_]+$/, 'Username can only contain letters, numbers, and underscores')
    .min(3, 'Username must be at least 3 characters')
    .max(20, 'Username cannot exceed 20 characters')
});
